export class GetITDTerminalsRequest {
    TerminalId: string = "";
    Branch: string= "";
    PayerTaxId: string= "";
    Department: string= "";
    Location: string= "";
    Take: number = 0;
    Skip: number= 0;
}
